var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useTheme } from '../Theme/Theme';
import { loadingStyle as style } from './style';
export const Loading = (props) => {
    const { render = () => React.createElement("div", null), isLoading } = props, rest = __rest(props, ["render", "isLoading"]);
    const theme = useTheme();
    if (!isLoading) {
        return render();
    }
    return React.createElement("div", Object.assign({}, rest, { className: style(theme, props) }));
};
//# sourceMappingURL=Loading.js.map